/**
 * ServiceAlert API Documentation
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const WebMessageType = {
    Sms2Webs: 'Sms2Webs',
    Sms2Internals: 'Sms2Internals',
    Facebook: 'Facebook',
    Twitter: 'Twitter'
} as const;
export type WebMessageType = typeof WebMessageType[keyof typeof WebMessageType];

